"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const material_1 = require("@mui/material");
const TableCell_1 = tslib_1.__importDefault(require("@mui/material/TableCell"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const Link_1 = require("../Link");
/**
 *
 * @category component
 */
const LinkCell = ({ columnId, text, linkTooltipProps, linkProps, secondaryText, secondaryTextTypographyProps, ...cellProps }) => {
    return (react_1.default.createElement(TableCell_1.default, { ...cellProps },
        react_1.default.createElement(material_1.Tooltip, { ...linkTooltipProps },
            react_1.default.createElement(Link_1.Link, { ...linkProps }, text)),
        secondaryText && (react_1.default.createElement(Typography_1.default, { component: "div", variant: "caption", ...secondaryTextTypographyProps }, secondaryText))));
};
exports.default = LinkCell;
